<div
  class="adam-container"
  id="adamftd-embedded-container-trade-data"
></div>
